<template>
  <div class="pl-4 pr-4">
    <div v-if="meeting">
      <h5 class="grey--text">Endereço de encontro</h5>
      <p class="text-body-2 text-truncate">
        {{ meeting }}
      </p>
    </div>

    <div v-if="keyLocation">
      <h5 class="grey--text">Endereço da chave</h5>
      <p class="text-body-2 text-truncate">
        {{ keyLocation }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BoardCardLocation',

  props: {
    host: {
      type: Object,
    },

    visitor: {
      type: String,
    },

    meeting: {
      type: String,
    },

    keyLocation: {
      type: String,
    },
  },
}
</script>
